'use client';

import Script from 'next/script';

import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { getRuntimeEnvironment } from '@/environment/get-runtime-environment';
import { RuntimeEnvironment } from '@/environment/runtime-environment';

export const FooterBlameHere = () => {
  if (getRuntimeEnvironment() != RuntimeEnvironment.PRD) {
    return null;
  }

  return (
    <div
      id="ra-verified-seal"
      className="mt-4 md:mt-3"
      data-analytics-event={AnalyticsEnum.CLICK_FOOTER_ITEM}
      data-analytics-properties={JSON.stringify({ item_footer: 'Reclame aqui' })}
    >
      <Script
        type="text/javascript"
        id="ra-embed-verified-seal"
        src="https://raichu-beta.s3.amazonaws.com/ra-verified/bundle.js"
        data-id="cFZocTItMEhhTWxxRkJDejptZWRwcmV2LWFnZW5kYW1lbnRvLW9ubGluZQ=="
        data-target="ra-verified-seal"
        data-model="2"
      >
      </Script>
    </div>
  );
};
